import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n      background-size: 8px;\n      width: 16px;\n      height: 16px;\n      top: 4px;\n      right: -5px;\n    "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    width: 64px;\n    height: 64px;\n  "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  position: relative;\n  width: 80px;\n  height: 80px;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n  ", "\n  ::after {\n    content: \"\";\n    display: ", ";\n    width: 20px;\n    height: 20px;\n    position: absolute;\n    top: 5px;\n    right: -6px;\n    background: #ca9c66 url(", ") no-repeat center;\n    background-size: 9px;\n    border-radius: 50%;\n    ", "\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    padding: 22px;\n    grid-gap: 13px;\n    grid-template-columns: repeat(auto-fit, minmax(64px, max-content));\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.12);\n  border-radius: 6px;\n  background-color: #ffffff;\n  flex: 1;\n  padding: 24px;\n  display: grid;\n  grid-gap: 16px;\n  grid-template-columns: repeat(auto-fit, minmax(80px, max-content));\n  ", "\n  justify-content: center;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: ", ";\n  position: absolute;\n  margin-top: 19px;\n  z-index: 1;\n  left: 0;\n  right: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    width: 64px;\n    height: 64px;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    width: 74px;\n    height: 74px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 90px;\n  height: 90px;\n  ", "\n  ", "\n  margin: auto;\n  position: relative;\n  img {\n    width: 100%;\n    height: 100%;\n  }\n  &:hover {\n    ", " {\n      background-color: ", ";\n      background-image: url(", ");\n      background-repeat: no-repeat;\n      background-position: center;\n      background-size: 15px;\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    top: 0px;\n    right: -13px;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    width: 24px;\n    height: 24px;\n    top: 3px;\n    right: -10px;\n    background-size: 13px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  position: absolute;\n  top: 6px;\n  right: -15px;\n  background-color: #dcaea9;\n  border-radius: 50%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-image: url(", ");\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
import checkImage from "images/check.svg";
import pensileImage from "images/pensile.svg";
export var Wrapper = styled.div(_templateObject());
export var Pensile = styled.div(_templateObject2(), pensileImage, media.xxLargeScreen(_templateObject3()), media.smallScreen(_templateObject4()));
export var Selected = styled.div(_templateObject5(), media.xxLargeScreen(_templateObject6()), media.smallScreen(_templateObject7()), Pensile, function (props) {
  return props.theme.button.colors.primary;
}, pensileImage);
export var Options = styled.div(_templateObject8(), function (props) {
  return props.active ? "flex" : "none";
});
export var OptionsInner = styled.div(_templateObject9(), media.xxLargeScreen(_templateObject10()));
export var Option = styled.div(_templateObject11(), function (props) {
  return props.selected ? "red" : "black";
}, media.xxLargeScreen(_templateObject12()), function (props) {
  return props.selected ? "block" : "none";
}, checkImage, media.xxLargeScreen(_templateObject13()));